import add_icon from './img/add_icon.svg';
import customHeaders, { getSpace } from '../../../common/headers';
import { OlegRulesHttps } from '../../../fetchUrls';
import { useCallback, useEffect, useState } from 'react';
import { ModalRulesTable } from './ModalRublesTable/ModalRublesTable';
import {
  DropDownSelector,
  ButtonBasic,
  InputDinamycPlaceholder,
  CheckboxToggle,
  Checkbox
} from '@lk-gtcom/ecomlab-components';
import { StepItem } from '../../StepItem/StepItem';
import settings_icon from './img/settings.svg';
import useGeneralStore from '../../../store/general';
import './ModalRules.scss';
import { TooltipBlack } from '../../Tooltip/TooltipBlack/TooltipBlack';
import info_icon from './img/info_icon.svg'
import { ModalExitReadyScenario } from '../ModalAddingReadyScenario/ModalExitReadyScenario/ModalExitReadyScenario';
import { ModalParamsRules } from './ModalParamsRules/ModalParamsRules';
import { periodWeek } from '../../../common/constant';
import { ModalComponent } from '../ModalComponent/ModalComponent';

// Карточка
// status == 'Активно'/ 'Не активно'
export const CardDrop = ({ ...props }) => {
  const {
    id,
    name,
    portal_name,
    description,
    status = false,
    onDragStart,
    onDragOver,
    onStrategieToggle,
    onGetParams,
    active,
    setCurrentCard
  } = props;

  const currentItem = active?.find((item) => item.id === id);
  const hasAttributes =
    Array.isArray(currentItem?.attributes) && currentItem.attributes.length > 0;

  return (
    <div
      className="col-item__card"
      draggable={true}
      onDragStart={(e) => onDragStart(props)}
      onDragOver={(e) => onDragOver(e)}
    >
      <div className='col-item__text-content'>
        <p className="text">{portal_name ? portal_name : name}</p>
        {description && <TooltipBlack
          child={<img className='info-icon' src={info_icon} />}
          text={description}
          left='initial'
          right='0'
        />}
      </div>

      <div
        className="status-content"
        style={{
          justifyContent: status && hasAttributes ? 'space-between' : 'end',
        }}
      >
        {status && hasAttributes && (
          <button
            className="col-item__btn_settings"
            onClick={(e) => {
              e.stopPropagation();
              onGetParams({ id, name, status });
              setCurrentCard(props)
            }}
          >
            <img src={settings_icon} />
          </button>
        )}
        <Checkbox
          green
          value={status}
          onChange={(e) => {
            if (onStrategieToggle) {
              onStrategieToggle({ ...props, status: e });
            }
          }}
        />
        {/* <div className={`status ${statusCard(status)}`}>{status}</div> */}
      </div>
    </div>
  );
};

// Колонка
export const ColItemDrop = ({
  title = '',
  arr = [],
  onDragStart,
  onDragOver,
  onDrop,
  loading = false,
  onStrategieToggle,
  onGetParams,
  active,
  setCurrentCard
}) => {
  return (
    <div className="col-item">
      <div className="col-item__header">
        <h3 className="title">
          {title} <span>{arr?.length ? arr.length : 0}</span>
        </h3>
      </div>
      <div
        className="col-item__list"
        onDragOver={(e) => e.preventDefault()}
        onDrop={(e) => onDrop(e)}
      // draggable={true}
      >
        {!loading
          ? arr?.map((props, ind) => {
            // Карточка
            const { id } = props;
            return (
              <CardDrop
                key={id}
                {...props}
                onDragStart={(e) => onDragStart(e)}
                onDragOver={(e) => onDragOver(e)}
                onStrategieToggle={(e) => onStrategieToggle(e)}
                onGetParams={(e) => onGetParams(e)}
                active={active}
                setCurrentCard={setCurrentCard}
              />
            );
          })
          : 'Loading...'}
        {arr?.length < 1 && (
          <div className="no-list">
            <img src={add_icon} />
            <p className="text">Добавьте правило</p>
          </div>
        )}
      </div>
    </div>
  );
};

const FiltersWrapper = ({
  id,
  type,
  placeholder,
  selectedData,
  onFilterChange,
  service_id,
  ind,
  edit
}) => {
  const selectedSpace = useGeneralStore((state) => state.selectedSpace);
  const headers = { ...customHeaders, ...getSpace(selectedSpace) };
  const [localSelectedData, setLocalSelectedData] = useState();
  const [optionsData, setOptionsData] = useState([]);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);

  const [search, setSearch] = useState('');

  const [nameInput, setNameInput] = useState(selectedData?.[id] || '');

  const fetchFilters = (filter_id) => {
    const url = `${OlegRulesHttps}/api/v1/${service_id}/filter`;

    const filters = Object.keys(selectedData).map((key) => {
      const value = selectedData[key];
      const data =
        Array.isArray(value) && value.length > 0
          ? value.map((item) => item.value)
          : ['all'];

      return {
        id: key,
        data: data,
      };
    });

    let filtersWithoutLast = filters;
    if (!filtersWithoutLast?.length) return


    const body = JSON.stringify({
      id: filter_id,
      page: page,
      limit: 50,
      filters: filtersWithoutLast,
    });

    fetch(url, { body, method: 'POST', headers, })
      .then((res) => {
        if (res.ok) {
          return res.json();
        } else {
          throw new Error(JSON.stringify(res.json()));
        }
      })
      .then((json) => {
        if (json) {
          const dataArr = json?.filter_data.map((el) => ({
            label: el.name,
            value: el.id,
          }));
          setTotal(json?.total)
          if (page > 1) {
            setOptionsData((prev) => [...prev, ...dataArr]);
          } else {
            setOptionsData([...dataArr]);
          }
        }
      })
      .catch((err) => console.error(err))
      .finally(() => { });
  };

  const [initial, setInitial] = useState(true);

  const handleSetSelectedData = (data) => {
    setLocalSelectedData(data);
    onFilterChange(id, data);
  };


  const debounce = (func, delay) => {
    let debounceTimer;
    return (...args) => {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => func(...args), delay);
    };
  };

  const handleInputChange = useCallback(
    debounce((value) => {
      onFilterChange(id, value);
    }, 300),
    []
  );

  const handleSetSelectedDataForInput = (value) => {
    setNameInput(value);
    handleInputChange(value);
  };

  useEffect(() => {
    setInitial(false);
  }, []);



  useEffect(() => {
    if (id == 16) return
    if (!initial) {

      if (edit && selectedData) {
        fetchFilters(id);
      }
      if (!edit) {
        fetchFilters(id);
      }
    }
  }, [page, search, selectedData]);

  useEffect(() => {
    if (selectedData?.[id] !== localSelectedData) {
      setLocalSelectedData(selectedData?.[id]);
    }
  }, [selectedData, id]);

  return (
    <>
      {type === 'string' ? (
        <InputDinamycPlaceholder
          state={[]}
          // onChange={handleSetSelectedData}
          size="s"
          onChange={handleSetSelectedDataForInput}
          textErr={'Неверное название правила'}
          placeholder={placeholder}
          changeValue={selectedData?.[id]}
          maxWidth={'300px'}
        />
      ) : (
        type.includes('array') && (
          <DropDownSelector
            options_prop={optionsData}
            total={total}
            state={localSelectedData}
            setState={handleSetSelectedData}
            placeholder={placeholder}
            fetchCallback={setPage}
            setInputChange={setSearch}
            multi={true}
            positionMenu={ind == 3}
          />
        )
      )}
    </>
  );
};

export default FiltersWrapper;

// Модальное окно
const ModalRules = ({ ...props }) => {
  const {
    setIsModal,
    status,
    rule_id,
    service_id,
    isEdit,
    setIsEdit,
    isCreate,
    setRuleInfo,
    // name,
    ruleName,
    handleSaveSuccess,
    setRuleIdPar,
    notification = false,
    // isActive,
    // setIsActive,
  } = props;
  const selectedSpace = useGeneralStore((state) => state.selectedSpace);
  const headers = { ...customHeaders, ...getSpace(selectedSpace) };

  const [edit, setEdit] = useState(isEdit ? isEdit : false);
  const [create, setCreate] = useState(isCreate ? isCreate : false);

  const [showExitModal, setShowExitModal] = useState(false);
  const [filterValuesInitial, setFilterValuesInitial] = useState([]);
  const [nameInitial, setNameInitial] = useState('');
  const [name, setName] = useState('');

  const [date, setDate] = useState(periodWeek());
  const [dateFrom, dateTo] = date;
  const [currentCard, setCurrentCard] = useState(null);
  const [loading, setLoading] = useState(false);
  const [active, setActive] = useState([]);
  const [disactive, setDisactive] = useState([]);
  const [isModalParametr, setIsModalParametr] = useState(false);
  const [ruleId, setRuleId] = useState(rule_id ? rule_id : -1);

  const [strategyInfo, setStrategyInfo] = useState(status ? { status } : {});
  const [strategyParams, setStrategyParams] = useState([]);
  const [strategyParamValue, setStrategyParamValue] = useState([]);

  const [filterData, setFilterData] = useState(null);

  const [filterValues, setFilterValues] = useState(null);
  const [filterValuesValid, setFilterValuesValid] = useState([]);
  const [validButton, setValidButton] = useState(false);
  const [saveStatus, setSaveStatus] = useState(false);

  const [isActive, setIsActive] = useState(null);
  const [isFocus, setIsFocus] = useState(false);

  // Модалка
  const [isModalTable, setIsModalTable] = useState(false)

  useEffect(() => {
    if (isCreate) {
      setRuleIdPar(1);
    }
    return () => {
      setRuleIdPar(1);
    };
  }, []);

  const handleFilterChange = (id, data) => {
    setFilterValues((prevValues) => ({
      ...prevValues,
      [id]: data,
    }));
  };

  const fetchRuleModel = (service_id) => {
    const url = `${OlegRulesHttps}/api/v1/${service_id}/rule/model`;

    fetch(url, {
      method: 'GET',
      headers,
    })
      .then((res) => {
        if (res.ok) {
          return res?.json();
        } else {
          throw new Error(JSON.stringify(res.json()));
        }
      })
      .then((json) => {
        // console.log('Rule model:', json);
      })
      .catch((err) => console.error(err))
      .finally(() => { });
  };

  const fetchRuleAttrsModel = (service_id, rule_id) => {
    const url = `${OlegRulesHttps}/api/v1/${service_id}/rule_attrs/model/${service_id}`;

    fetch(url, {
      method: 'GET',
      headers,
    })
      .then((res) => {
        if (res.ok) {
          return res?.json();
        } else {
          throw new Error(JSON.stringify(res.json()));
        }
      })
      .then((json) => {
        setFilterData(json);
      })
      .catch((err) => console.error(err))
      .finally(() => { });
  };

  useEffect(() => {
    fetchRuleModel(service_id);
    fetchRuleAttrsModel(service_id, rule_id);
  }, []);

  const onCreate = () => {
    const url = `${OlegRulesHttps}/api/v1/${service_id}/rule`;

    // const id = edit ? { id: ruleId } : { rule_id };
    const id = edit ? { id: ruleId } : { rule_id: service_id };

    const attributes = filterData.map((attr) => {
      const values = filterValues[attr.id] || [];
      let valueData, labelData;

      if (attr.type.includes('array')) {
        if (attr.type === 'array[integer]') {
          valueData = Array.isArray(values)
            ? values.map((item) => parseInt(item.value, 10))
            : [];
          labelData = Array.isArray(values)
            ? values.map((item) => item.label)
            : [];
        } else {
          valueData = Array.isArray(values)
            ? values.map((item) => item.value)
            : [];
          labelData = Array.isArray(values)
            ? values.map((item) => item.label)
            : [];
        }
      } else {
        valueData = values;
        labelData = values;
      }

      return {
        attr_id: attr.id,
        value: {
          type: attr.type,
          value: valueData,
          label: labelData,
        },
      };
    });

    const body = JSON.stringify({
      ...id,
      is_active: true,
      attributes: attributes,
    });

    fetch(url, {
      body,
      method: edit ? 'PUT' : 'POST',
      headers: headers,
    })
      .then((res) => {
        if (res.ok) {
          return res.json();
        } else {
          return res.json().then((err) => {
            throw new Error(JSON.stringify(err));
          });
        }
      })
      .then(({ id }) => {
        setCreate(false);
        setRuleId(id);
        setIsEdit(true);
        setEdit(true);
        handleSaveSuccess();
        onGetRuleParams();
      })
      .catch((err) => console.error('Error:', err))
      .finally(() => {
        setLoading(false);
      });
  };

  const onDeleteStrategy = (id) => {
    const url = `${OlegRulesHttps}/api/v1/${service_id}/strategy`;

    const body = JSON.stringify({
      id,
    });

    fetch(url, {
      body,
      method: 'DELETE',
      headers,
    })
      .then((res) => {
        if (res.ok) {
          return res?.json();
        } else {
          throw new Error(JSON.stringify(res.json()));
        }
      })
      .then(() => {
        fetchStrategies();
        fetchClientStrategies();
      })
      .catch((err) => console.error(err))
      .finally(() => {
        setLoading(false);
      });
  };

  const onChangeStatus = () => {
    const url = `${OlegRulesHttps}/api/v1/${service_id}/rule/status`;

    const body = JSON.stringify({
      id: ruleId,
      is_active: !isActive,
    });

    fetch(url, {
      body,
      method: 'PATCH',
      headers,
    })
      .then((res) => {
        if (res.ok) {
          return res?.json();
        } else {
          throw new Error(JSON.stringify(res.json()));
        }
      })
      .then((res) => {
        console.log(res);
      })
      .catch((err) => console.error(err))
      .finally(() => {
        setLoading(false);
      });
  };

  const onChangeStrategy = ({ status, id }) => {
    const url = `${OlegRulesHttps}/api/v1/${service_id}/strategy`;

    const exists = active.some((item) => item.id === id);

    const param = Object.keys(strategyParamValue).map((id) => ({
      attr_id: id,
      value: strategyParamValue[id],
    }));

    const statusCheckBody =
      status && !exists
        ? { strategy_id: id, client_rule_id: ruleId, is_active: true }
        : { id };

    const body = JSON.stringify({
      ...statusCheckBody,
      attributes: param,
    });

    fetch(url, {
      body,
      method: status && !exists ? 'POST' : 'PUT',
      headers,
    })
      .then((res) => {
        if (res.ok) {
          return res?.json();
        } else {
          throw new Error(JSON.stringify(res.json()));
        }
      })
      .then((json) => {
        fetchStrategies();
        fetchClientStrategies();
      })
      .catch((err) => console.error(err))
      .finally(() => {
        setLoading(false);
        setStrategyInfo({});
        setStrategyParams([])
        setStrategyParamValue({});
      });
  };

  const fetchStrategies = () => {
    const url = `${OlegRulesHttps}/api/v1/${service_id}/strategy/model/${ruleId}/list`;

    fetch(url, {
      method: 'GET',
      headers,
    })
      .then((res) => {
        if (res.ok) {
          return res?.json();
        } else {
          throw new Error(JSON.stringify(res.json()));
        }
      })
      .then((json) => {
        setDisactive(json?.map((el) => ({ ...el, status: false })));
        // setActive(active?.map(el => ({ ...el, status: true })))
        // setDisactive(disactive?.map(el => ({ ...el, status: false })))
      })
      .catch((err) => console.error(err))
      .finally(() => {
        setLoading(false);
      });
  };

  const fetchClientStrategies = () => {
    const url = `${OlegRulesHttps}/api/v1/${service_id}/strategy/client/${ruleId}/list`;

    fetch(url, {
      method: 'GET',
      headers,
    })
      .then((res) => {
        if (res.ok) {
          return res?.json();
        } else {
          throw new Error(JSON.stringify(res.json()));
        }
      })
      .then((json) => {
        setActive(json?.map((el) => ({ ...el, status: true })));
      })
      .catch((err) => console.error(err))
      .finally(() => {
        setLoading(false);
      });
  };

  const onGetParams = async (id, name, status) => {
    setStrategyParams([]);
    setStrategyParamValue([]);

    const exists = active.some((item) => item.id === id);

    let url;
    if (status) {
      url = `${OlegRulesHttps}/api/v1/${service_id}/strategy_attrs/${status && !exists ? 'model' : 'client'
        }/${id}`;
    } else {
      url = `${OlegRulesHttps}/api/v1/${service_id}/strategy_attrs/${status && !exists ? 'model' : 'client'
        }/${id}`;
    }

    await fetch(url, {
      method: 'GET',
      headers,
    })
      .then((res) => {
        if (res.ok) {
          return res?.json();
        } else {
          throw new Error(JSON.stringify(res.json()));
        }
      })
      .then((json) => {
        if (json?.length > 0) {
          setStrategyInfo({ name, status, id });
          setStrategyParams(json);
          setIsModalParametr(true);
        } else {
          onChangeStrategy({ status, id });
        }
        // setIsModalParametr(true);
      })
      .catch((err) => {
        setStrategyParams([]);
        setStrategyInfo({
          name: 'Произошла ошибка',
          status,
          id,
        });
        console.error(err);
      })
      .finally(() => {
        setLoading(false);

      });
  };

  const onGetRuleParams = () => {
    const url = `${OlegRulesHttps}/api/v1/${service_id}/rule_attrs/client/${rule_id}`;

    fetch(url, {
      method: 'GET',
      headers,
    })
      .then((res) => {
        if (res.ok) {
          return res?.json();
        } else {
          throw new Error(JSON.stringify(res.json()));
        }
      })
      .then((json) => {
        setIsActive(json?.is_active);
        const newFilterValues = json?.attributes?.reduce((acc, attr) => {
          if (attr.value.type.includes('array')) {
            acc[attr.attr_id] = attr.value.value.map((value, index) => ({
              label: attr.value.label[index],
              value: value,
            }));
          } else {
            acc[attr.attr_id] = attr.value.value;
          }
          return acc;
        }, {});
        setTimeout(() => {
          setFilterValues(newFilterValues);
          setFilterValuesValid(newFilterValues);
          setFilterValuesInitial(newFilterValues);
          setName(newFilterValues?.name || '');
          setNameInitial(newFilterValues?.name || '');
        }, [500]);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const hasChanges = () => {
    return (
      JSON.stringify(filterValues) !== JSON.stringify(filterValuesInitial) ||
      name !== nameInitial
    );
  };

  const handleCloseClick = () => {
    if (hasChanges()) {
      setShowExitModal(true);
    } else {
      onReset();
      setIsModal(false);
    }
  };

  const getClientParams = async (id, name, status) => {
    await onGetParams(id, name, status);
    // onGetStrategyParams(id, name, status)
  };

  const onReset = () => {
    setRuleInfo({});
    setStrategyInfo({});
    setStrategyParamValue({});
    setStrategyParams([]);
    // setRuleId();
    setFilterValues([]);
  };

  const onStrategieToggle = (props) => {
    const { id, name, status, param } = props;

    if (!status) {
      onDeleteStrategy(id);
    } else {
      setStrategyInfo({ name, status, id });
      onGetParams(id, name, status);
    }
  };

  const dragStartHandler = (e, card) => {
    // Перетаскиваемая карточка
    setCurrentCard(e);
  };

  const dragOverHandler = (e, card) => {
    e.preventDefault();
  };

  const dropHandler = (e, status) => {
    e.preventDefault();
    if (!currentCard) return;
    onStrategieToggle({ ...currentCard, status });
  };

  useEffect(() => {
    if (!edit) {
      onReset();
    }
  }, [selectedSpace]);

  useEffect(() => {
    // if (edit) {
    onGetRuleParams();
    // }
  }, [edit, selectedSpace]);

  useEffect(() => {
    if (edit) {
      fetchStrategies();
      fetchClientStrategies();
    }
  }, [ruleId, selectedSpace]);

  const onSave = () => {
    setLoading(true);
    onCreate()
      .then(() => {
        setLoading(false);
        setSaveStatus('saved');
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  const compareObjects = (obj1, obj2) => {
    if (
      typeof obj1 !== 'object' ||
      typeof obj2 !== 'object' ||
      obj1 === null ||
      obj2 === null
    ) {
      return false;
    }

    const keys1 = Object.keys(obj1);
    const keys2 = Object.keys(obj2);
    if (keys1.length !== keys2.length) {
      return false;
    }

    let isEqual = true;

    keys1.forEach((key) => {
      if (!obj2.hasOwnProperty(key)) {
        isEqual = false;
        return;
      }

      const val1 = obj1[key];
      const val2 = obj2[key];

      if (Array.isArray(val1) && Array.isArray(val2)) {
        if (val1.length !== val2.length) {
          isEqual = false;
          return;
        }
        val1.forEach((item, index) => {
          if (
            item.value !== val2[index]?.value ||
            item.label !== val2[index]?.label
          ) {
            isEqual = false;
          }
        });
      } else if (val1 !== val2) {
        isEqual = false;
      }
    });

    return isEqual;
  };

  useEffect(() => {
    const areEqual = compareObjects(filterValues, filterValuesValid);
    setValidButton(areEqual);
  }, [filterValues]);


  useEffect(() => {
    if (strategyParams?.[0]?.type == 'boolean') {
      setStrategyParamValue((prev) => {
        return {
          ...prev,
          [strategyParams?.[0]?.id]: {
            type: 'boolean',
            value: false
          },
        };
      })
    }
  }, [strategyParams]);

  const [selectedItems, setSelectedItems] = useState([])

  return (
    <>
      {isModalTable && <ModalRulesTable
        setIsModal={setIsModalTable}
        filterValues={filterValues}
        setFilterValues={setFilterValues}
        selectedItems={selectedItems}
        setSelectedItems={setSelectedItems}
      />}

      <ModalComponent
        title={edit ? 'Редактирование' : 'Создание'}
        onClose={(e) => {
          setIsModal(false);
          setIsEdit(false);
          setEdit(false);
          onReset();
        }}
        childHeader={
          <>
            {filterData?.map((item) => {
              if (item.type === 'string') {
                return (
                  <FiltersWrapper
                    key={item.id}
                    id={item.id}
                    type={item.type}
                    service_id={service_id}
                    placeholder={item.portal_name}
                    selectedData={filterValues}
                    onFilterChange={handleFilterChange}
                    edit={edit}
                    maxWidth='auto'
                  />
                );
              }
            })}

            <div className='modal-promotion-rules__header-left'>
              <CheckboxToggle
                text={isActive ? ' Активен' : ' Не активен'}
                color="blue"
                value={isActive}
                onChange={(e) => {
                  setIsActive(e);
                  onChangeStatus();
                }}
              />

              <div className="submitBtn">
                <ButtonBasic
                  green
                  width="180px"
                  text={ create ? 'Создать' : 'Сохранить изменения'}
                  loading={loading}
                  size="40px"
                  onClick={() => onSave()}
                  disabled={validButton}
                />
              </div>
            </div>
          </>
        }
        child={
          <div
            className="modal-promotion-rules container"
            onClick={(e) => {
              let el = e.target;
              if (!el.closest('.modal-params-rules')) {
                setIsModalParametr(false);
                // onChangeStrategy()
              }
            }}
          >
            {notification &&
              <StepItem
                title={'Выберите куда хотите получать уведомления'}
                description={<>
                  Заполните все обязательные поля, которые находятся ниже и нажмите на
                  кнопку “Следующий шаг”. <span style={{ color: 'red' }}>Красными звездочками</span> выделены
                  обязательные пункты для заполнения
                </>}
              />}

            <div className="modal-promotion-rules__toolbar-top">
              {filterData?.map((item) => {
                if (item.portal_name == 'Аккаунт') {
                  return (
                    <FiltersWrapper
                      key={item.id}
                      id={item.id}
                      type={item.type}
                      service_id={service_id}
                      placeholder={item.portal_name}
                      selectedData={filterValues}
                      onFilterChange={handleFilterChange}
                      edit={edit}
                    />
                  );
                }
              })}
            </div>

            <div className="modal-promotion-rules__toolbar-medium">
              {filterData?.map((item, ind) => {
                if (item.type.includes('array') && item.portal_name != 'Аккаунт') {
                  if (item?.id == 22) {
                    return null
                  } else return (
                    <FiltersWrapper
                      ind={ind}
                      key={item.id}
                      id={item.id}
                      type={item.type}
                      service_id={service_id}
                      placeholder={item.portal_name}
                      selectedData={filterValues}
                      onFilterChange={handleFilterChange}
                      edit={edit}
                    />
                  );
                }
              })}

              <ButtonBasic
                blue
                text='Выбор по товарам'
                onClick={(e) => setIsModalTable(true)}
                style={{
                  marginLeft: 'auto'
                }}
              />
            </div>

            {notification && <StepItem
              title={'Выберите о чем получать уведомления'}
            />
            }

            <div className="modal-promotion-rules__content">
              <div className="rules-content">
                {!create || isEdit ? (
                  <section className="rules-content__content">
                    <div className="rules-content__tooltip">
                      Активируйте нужное правило переключателем или просто
                      перенесетие его вправо
                      <Checkbox green checked />
                    </div>
                    <div className="column-group">
                      <ColItemDrop
                        title="Доступные"
                        loading={loading}
                        arr={disactive}
                        onDragStart={(e) => dragStartHandler(e)}
                        onDragOver={(e) => dragOverHandler(e)}
                        onDrop={(e) => dropHandler(e, false)}
                        onStrategieToggle={(e) => onStrategieToggle(e)}
                        onGetParams={(e) => getClientParams(e)}
                        setCurrentCard={setCurrentCard}
                      />

                      <ColItemDrop
                        title="Активные"
                        arr={active}
                        loading={loading}
                        onDragStart={(e) => dragStartHandler(e)}
                        onDragOver={(e) => dragOverHandler(e)}
                        onDrop={(e) => dropHandler(e, true)}
                        onStrategieToggle={(e) => onStrategieToggle(e)}
                        // onGetParams={(e) => getClientParams(e)}
                        onGetParams={(e) => {
                          const { id, name, status } = e;
                          getClientParams(id, name, status);
                        }}
                        active={active}
                        setCurrentCard={setCurrentCard}
                      />
                    </div>
                  </section>
                ) : null}
              </div>
            </div>

            {isModalParametr && strategyInfo?.name && (
              <ModalParamsRules
                strategyInfo={strategyInfo}
                currentCard={currentCard}
                strategyParams={strategyParams}
                strategyParamValue={strategyParamValue}
                setStrategyParamValue={setStrategyParamValue}
                setStrategyParams={setStrategyParams}
                onClose={() => setIsModalParametr(false)}
                onChangeStrategy={onChangeStrategy}
              />
            )}

            {showExitModal && (
              <ModalExitReadyScenario
                setIsModal={setShowExitModal}
                onClose={() => {
                  setShowExitModal(false);
                  setIsModal(false);
                  onReset();
                }}
                onSave={() => {
                  onCreate();
                  setShowExitModal(false);
                  setIsModal(false);
                }}
              />
            )}
          </div>
        }
      />
    </>
  );
};

export { ModalRules };